// initial state
import axios from "axios";

const state = () => ({
    all: [],
    clients: [],
    suppliers: [],
    createGroupSlideOutOpen: false,
    group: {
        id: null,
        name: null,
        organisations: null
    },
    createSupplierChainSlideOutOpen: false,
    hotel_chain: {
        id: null,
        name: null,
    }
})

// getters
const getters = {}

// actions
const actions = {
    async getAllClients ({ commit }) {
        axios.get(route('frontend.organisations.clients.list')).then(result => {
            commit('setClients', result.data)
        });
    },
    async getAllSuppliers ({ commit }) {
        axios.get(route('frontend.organisations.suppliers.list')).then(result => {
            commit('setSuppliers', result.data)
        });
    },
    // async getAllHotelChains ({ commit }) {
    //     axios.get(route('frontend.organisations.chains.list')).then(result => {
    //         commit('setHotelChains', result.data)
    //     });
    // },
    openCreateGroup ({ commit }, group = null ) {
        commit('openCreateGroup', group)
    },
    closeCreateGroup ({ commit }) {
        commit('closeCreateGroup', false)
    },
    addClientToGroup( { commit }, client) {
        commit('addClientToGroup', client)
    },
    deleteClientFromGroup({commit}, client) {
        commit('deleteClientFromGroup', client);
    },
    openCreateSupplierChain({ commit }, hotel_chain = null) {
        commit('openCreateSupplierChain', hotel_chain);
    },
    closeCreateSupplierChain ({ commit }) {
        commit('closeCreateSupplierChain', false)
    },
}

// mutations
const mutations = {
    setOrganisations (state, organisations) {
        state.all = organisations
    },
    setClients (state, clients) {
        state.clients = clients
    },
    setSuppliers (state, suppliers) {
        state.suppliers = suppliers
    },
    // setHotelChains (state, hotel_chains) {
    //     state.hotel_chains = hotel_chains
    // },
    openCreateGroup(state, group) {
        state.createGroupSlideOutOpen = true;
        state.group = group;
    },
    closeCreateGroup(state, value) {
        state.createGroupSlideOutOpen = value;
        state.group = null;
    },
    addClientToGroup(state, client) {
        state.group.organisations.push(client);
    },
    deleteClientFromGroup(state, client) {
        state.group.organisations = state.group.organisations.filter(x => {
            return x.id !== client.id;
        })
    },
    openCreateSupplierChain(state, hotel_chain) {
        console.log(hotel_chain);
        state.createSupplierChainSlideOutOpen = true;
        state.hotel_chain = hotel_chain;
    },
    closeCreateSupplierChain(state, value) {
        state.createSupplierChainSlideOutOpen = value;
        state.hotel_chain = null;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
